// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Eqpt","footer":"styles_footer__2AdM4","passCodeTooltip":"styles_passCodeTooltip__2IUtq"};